import React from 'react';
import { createRoot } from 'react-dom/client'; // Use createRoot for React 18+
import App from './App';
import { HashRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import { persistor, store } from './component/redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './config';
import { MsalProvider } from '@azure/msal-react';

// Initialize MSAL instance for Azure authentication
const msalInstance = new PublicClientApplication(msalConfig);

// Create root for React 18+ compatibility
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <React.StrictMode> 
    <HashRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <MsalProvider instance={msalInstance}>
            <App />
          </MsalProvider>
        </PersistGate>
      </Provider>
    </HashRouter>
  </React.StrictMode>
);
